export const GET_ALL_ADVERTISEMENTS_START =
  'GET_ALL_ADVERTISEMENTS_START';
export const GET_ALL_ADVERTISEMENTS_SUCCESS =
  'GET_ALL_ADVERTISEMENTS_SUCCESS';
export const GET_ALL_ADVERTISEMENTS_ERROR =
  'GET_ALL_ADVERTISEMENTS_ERROR';
